import {
  DateTimeFormatter,
  Duration,
  Instant,
  LocalDate,
  LocalDateTime,
  LocalTime,
  ZoneId,
} from "@js-joda/core"
import { Locale } from "@js-joda/locale"

export const formatDaysBetween = (start: Instant, end: Instant) => {
  const durationMillis = Duration.between(start, end).toMillis()
  const minutes = durationMillis / (60 * 1000)
  const hours = minutes / 60
  const days = hours / 24

  if (minutes < 1) {
    return "Just now"
  }

  if (minutes < 60) {
    const roundedMinutes = Math.round(minutes)
    return roundedMinutes === 1 ? "1 minute" : `${roundedMinutes} minutes`
  }

  if (hours < 24) {
    const roundedHours = Math.round(hours)
    return roundedHours === 1 ? "1 hour" : `${roundedHours} hours`
  }

  const roundedDays = Math.round(days)
  return roundedDays === 1 ? "1 day" : `${roundedDays} days`
}

export const formatDateTime = (dateTime: Instant, pattern: string) => {
  const localDateTime = LocalDateTime.ofInstant(dateTime, ZoneId.of("UTC")) // Adjust the time zone as needed
  const formatter = DateTimeFormatter.ofPattern(pattern).withLocale(
    Locale.US
  )
  return localDateTime.format(formatter)
}

export const formatTime = (time: LocalTime, pattern: string) => {
  const formatter = DateTimeFormatter.ofPattern(pattern).withLocale(
    Locale.US
  )
  return time.format(formatter)
}

export const formatDate = (date: LocalDate, pattern: string) => {
  const formatter = DateTimeFormatter.ofPattern(pattern).withLocale(
    Locale.US
  )
  return date.format(formatter)
}
